module.exports = __webpack_public_path__ + "img/portraits_30_H.c3b42a23.webp";